// import { CRM_SYSTEMS } from "@/types/crm/_shared/crm_system";
import { CRM_SYSTEMS_IDS } from "@/features/crm_system/lib/_core/crmSystem/crmSystem.constants.gen";
import { z } from "zod";

// export const crmSystemSchema = z.nativeEnum(CRM_SYSTEMS)
export const crmSystemSchema = z.enum(CRM_SYSTEMS_IDS);